import React from 'react'
import { useEffect } from 'hooks'
import { connect } from 'react-redux'
import { fetchLabels, fetchAccount } from 'store/actions'

const TranslationSwitch = ({ lc, languages, fetchLabels, fetchAccount, shouldFetch }) => {
  useEffect(() => {
    shouldFetch && fetchAccount()
  }, [])

  return (
    <div className="TranslationSwitch">
      {languages.map(({ name, isoCode }) => (
        <span
          key={isoCode}
          className={`translation ${isoCode === lc ? 'translation--active' : ''}`}
          onClick={() => fetchLabels(isoCode)}
        >
          {name}
        </span>
      ))}
    </div>
  )
}

const mapStateToProps = ({ siteConfig: { supportedLanguages }, account, myProfile }) => ({
  lc: supportedLanguages.find(e => e.id == account.main.lc)?.isoCode,
  languages: supportedLanguages,
  shouldFetch: !myProfile?.error && !account.main?.loading,
})

export default connect(mapStateToProps, { fetchLabels, fetchAccount })(TranslationSwitch)
